import { useAuthService } from '@/modules/auth/auth.service';
import { PathComponentEnum, AccessPermissionsEnum } from '@/router/constants';
import i18n from '@/i18n';
import store from '@/store';

export async function accessGuardMiddleware(to, from, next) {
  const { checkHasPermission, getUserPermissions } = useAuthService();
  const { accessPermissions, roles } = to.meta;

  if (!accessPermissions && !roles) {
    next();
    return;
  }

  // Проверяем роль пользователя - back-office пользователи обходят проверку разрешений
  const userRole = store.getters.role;
  if (userRole === 'back-office') {
    next();
    return;
  }

  // Check roles if defined
  if (roles && roles.length > 0) {
    if (!roles.includes(userRole)) {
      const currentLocale = typeof i18n.global.locale === 'object' ? i18n.global.locale.value : i18n.global.locale;
      next({
        name: PathComponentEnum.accessError,
        params: { locale: currentLocale },
      });
      return;
    }
  }

  // A roles-only route has no additional client permission requirement.
  // Explicit permission lists, including an empty list, keep their existing checks.
  if (roles?.length > 0 && accessPermissions === undefined) {
    next();
    return;
  }

  // Ensure permissions are loaded before checking
  try {
    await getUserPermissions();
  } catch (error) {
    console.error('Failed to load permissions:', error);
    // If we can't load permissions, redirect to access error
    const currentLocale = typeof i18n.global.locale === 'object' ? i18n.global.locale.value : i18n.global.locale;
    next({
      name: PathComponentEnum.accessError,
      params: { locale: currentLocale },
    });
    return;
  }

  if (checkHasPermission(accessPermissions)) {
    next();
    return;
  }

  // TEMPORARY: Allow statistics for operator even if permission is missing
  if (userRole === 'operator' && (accessPermissions?.includes(AccessPermissionsEnum.CAN_READ_STATISTIC) || accessPermissions?.includes(AccessPermissionsEnum.CAN_READ_CATALOG_POINTS))) {
    next();
    return;
  }

  // Handle locale ref correctly
  const currentLocale = typeof i18n.global.locale === 'object' ? i18n.global.locale.value : i18n.global.locale;

  next({
    name: PathComponentEnum.accessError,
    params: { locale: currentLocale },
  });
}
